'use client';
import { useEffect } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';

type EventSharedProps = { event: 'pageview_event'; dataLayerName?: string };

interface PageviewEventProps extends EventSharedProps {
	event: 'pageview_event';
	var_pagetype: string;
}

export type GtmEventTrackingProps = PageviewEventProps;

const GtmEventTracking = ({ ...props }: GtmEventTrackingProps) => {
	const { dataLayerName, ...otherProps } = props;

	useEffect(() => {
		sendGTMEvent(
			{
				var_domain: process.env.NEXT_PUBLIC_URL,
				...otherProps,
			},
			dataLayerName,
		);
	}, []);

	return null;
};

export default GtmEventTracking;
